<template>
  <el-dialog :title='dialogTitle' :visible.sync='dialogVisible' :close-on-click-modal='false'
             @close='dialogClose' width='1050px' append-to-body>
    <el-form :model='form' label-width='130px' label-position='right' :rules='rules'
             ref='ruleForm' class='dialogForm mt20'>
      <div-border label='基础信息'>
        <el-row class='p10'>
          <el-col :span='12'>
            <el-form-item label='考核指标：' prop='examineTarget'>
              <el-select :disabled='form.isUpdate === "1"' v-model='form.examineTarget' size='mini'
                         style='width:100%'
                         placeholder='请选择考核指标' value-key='id' @change='clearTable'>
                <el-option v-for='item in examineTargetOptions' :key='item.value'
                           :label='item.label' :value='item.value' />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='指标与权重：' prop='targetWeight'>
              <el-input :disabled='form.isUpdate === "1"' v-model='form.targetWeight' size='mini'
                        placeholder='请输入指标与权重' />
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='分值：' prop='score'>
              <el-input :disabled='form.isUpdate === "1"' v-model='form.score' size='mini'
                        placeholder='请输入分值' />
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='计算公式：' prop='calculationFormula'>
              <el-input :disabled='form.isUpdate === "1"' v-model='form.calculationFormula'
                        size='mini' placeholder='请输入计算公式' />
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='目标值：' prop='targetValue'>
              <el-input :disabled='form.isUpdate === "1"' v-model='form.targetValue' size='mini'
                        placeholder='请输入目标值' />
              <!--              <el-row :gutter='60'>
                              <el-col :span='8' class='p0'>
                                <el-select v-model='form.targetValue.label' size='mini'
                                           style='width:100%;' placeholder='请选择' value-key='id'>
                                  <el-option v-for='item in targetValueOptions' :key='item.value'
                                             :label='item.label' :value='item.value' />
                                </el-select>
                              </el-col>
                              <el-col :span='14' class='pl10'>
                                <el-input v-model='form.targetValue.value' type='number' size='mini'
                                          placeholder='请输入目标值'>
                                  <template slot='append'>%</template>
                                </el-input>
                              </el-col>
                            </el-row>-->
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='数据提供部门：' prop='provideDepartment'>
              <el-input :disabled='form.isUpdate === "1"' v-model='form.provideDepartment'
                        size='mini' placeholder='请输入数据提供部门' />
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='考核周期：' prop='examineDate'>
              <el-select :disabled='form.isUpdate === "1"' v-model='form.examineDate' size='mini'
                         style='width:100%'
                         placeholder='请选择考核周期' value-key='id'>
                <el-option v-for='item in examineDateOptions' :key='item.value'
                           :label='item.label' :value='item.value' />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-form-item label='考核部门：' prop='examineDepartment'>
              <el-input :disabled='form.isUpdate === "1"' v-model='form.examineDepartment'
                        size='mini' placeholder='请输入考核部门' />
            </el-form-item>
          </el-col>
        </el-row>
      </div-border>
      <div-border label='评分标准' divStyle='margin-top: 10px' class='p10'
                  v-if='form.examineTarget === "0"'>
        <el-table border :data='form.scoringCriteriaList' v-loading='tableLoading'>
          <el-table-column label='序号' align='center' type='index' width='50' />
          <el-table-column label='评分标准开始值' align='center'>
            <template slot-scope='scope'>
              <el-input v-if='scope.$index !== 0' type='number'
                        v-model='form.scoringCriteriaList[scope.$index].startPrice'
                        size='mini' style='width:100%' placeholder='请输入'>
                <template slot='append'>%</template>
              </el-input>
              <div v-else>{{ scope.row.startPrice }}</div>
            </template>
          </el-table-column>
          <el-table-column label='评分标准结束值' align='center'>
            <template slot-scope='scope'>
              <el-input type='number' v-model='form.scoringCriteriaList[scope.$index].endPrice'
                        size='mini' style='width:100%' placeholder='请输入'>
                <template slot='append'>%</template>
              </el-input>
            </template>
          </el-table-column>
          <el-table-column label='分值' align='center'>
            <template slot-scope='scope'>
              <el-input type='number'
                        v-model='form.scoringCriteriaList[scope.$index].score'
                        size='mini' style='width:100%' placeholder='请输入分值' />
            </template>
          </el-table-column>
          <el-table-column label='操作' align='center'>
            <div slot-scope='scope'
                 style='display:flex;align-items:center;justify-content:center'>
              <img
                v-if='scope.$index !== 0 && scope.$index + 1 === form.scoringCriteriaList.length'
                alt='' :src="require('@/assets/images/u725.png')"
                :style="'width:22px;height:22px;cursor: pointer;'"
                @click='removeClick(scope.$index)' />
              <img
                v-if='scope.$index !== 0 && Number(form.scoringCriteriaList[scope.$index].startPrice) < Number(form.scoringCriteriaList[scope.$index-1].endPrice)'
                alt='' :src="require('@/assets/images/u725.png')"
                :style="'width:22px;height:22px;cursor: pointer;'"
                @click='removeClick(scope.$index)' />
              <img v-else-if='scope.$index+1 === form.scoringCriteriaList.length' alt=''
                   :src="require('@/assets/images/add.png')"
                   :style="'width:22px;height:22px;cursor: pointer;'"
                   @click='addImgClick' />
              <span v-else>-</span>
            </div>
          </el-table-column>
        </el-table>
      </div-border>
      <div class='flex-center-center mt20'>
        <el-button size='medium' class='searchBtn' :loading='submitLoading' @click='submit'>确认
        </el-button>
        <el-button size='medium' class='resetBtn' @click='dialogClose'>关闭</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
  import BatchImport from '@/components/batchImport';
  import DivBorder from '@/components/divBorder';
  import {
    indicatorSettingsGrading,
    indicatorSettingsInfoAdd,
    indicatorSettingsInfoUpdate,
  } from '@/service/supplierAssessment';

  export default {
    name: 'indicatorManagementForm',
    components: {
      BatchImport,
      DivBorder,
    },
    data() {
      return {
        importLoading: false,
        dialogVisible: false,
        dialogTitle: '新增',
        defaultForm: {},
        form: {
          scoringCriteriaList: [{
            startPrice: 0,
            sort: 1,
          }],
        },
        rules: {
          examineTarget: [
            {
              required: true,
              message: '请选择考核指标',
              trigger: 'blur',
            },
          ],
          examineDate: [
            {
              required: true,
              message: '请选择考核周期',
              trigger: 'blur',
            },
          ],
          examineDepartment: [
            {
              required: true,
              message: '请输入考核部门',
              trigger: 'blur',
            },
          ],
          targetWeight: [
            {
              required: true,
              message: '请输入指标与权重',
              trigger: 'blur',
            },
          ],
          score: [
            {
              required: true,
              message: '请输入分值',
              trigger: 'blur',
            },
          ],
          calculationFormula: [
            {
              required: true,
              message: '请输入计算公式',
              trigger: 'blur',
            },
          ],
          targetValue: [
            {
              required: true,
              message: '请输入目标值',
              trigger: 'blur',
            },
          ],
          provideDepartment: [
            {
              required: true,
              message: '请输入数据提供部门',
              trigger: 'blur',
            },
          ],
        },
        submitLoading: false,
        examineTargetOptions: [
          {
            label: 'KPI指标',
            value: '0',
          },
          {
            label: '物流综合服务能力',
            value: '1',
          },
        ],
        examineDateOptions: [
          {
            label: '月度',
            value: '月度',
          },
          {
            label: '季度',
            value: '季度',
          },
          {
            label: '年度',
            value: '年度',
          },
        ],
        targetValueOptions: [
          {
            label: '小于',
            value: '<',
          },
          {
            label: '等于',
            value: '=',
          },
          {
            label: '大于',
            value: '>',
          },
          {
            label: '小于等于',
            value: '<=',
          },
          {
            label: '大于等于',
            value: '>=',
          },
        ],
        brandOptions: [],
        basicId: '',
        tableLoading: false,
      };
    },
    mounted() {
      this.defaultForm = JSON.parse(JSON.stringify(this.form));
    },
    methods: {
      addImgClick() {
        if (!(this.form.scoringCriteriaList[this.form.scoringCriteriaList.length - 1].startPrice === 0)) {
          if (!this.form.scoringCriteriaList[this.form.scoringCriteriaList.length - 1].startPrice) return this.$message.warning('请先输入评分标准开始值！');
        }
        if (!this.form.scoringCriteriaList[this.form.scoringCriteriaList.length - 1].endPrice) return this.$message.warning('请先输入评分标准结束值！');
        if (!this.form.scoringCriteriaList[this.form.scoringCriteriaList.length - 1].score) return this.$message.warning('请先输入分值！');
        if (isNaN(Number(this.form.scoringCriteriaList[this.form.scoringCriteriaList.length - 1].endPrice))) return this.form.scoringCriteriaList[this.form.scoringCriteriaList.length - 1].endPrice = '';
        if (Number(this.form.scoringCriteriaList[this.form.scoringCriteriaList.length - 1].endPrice) < Number(this.form.scoringCriteriaList[this.form.scoringCriteriaList.length - 1].startPrice)) {
          this.form.scoringCriteriaList[this.form.scoringCriteriaList.length - 1].endPrice = '';
          return this.$message.warning('结束数量必须小于开始数量！');
        }
        this.form.scoringCriteriaList.push({ sort: this.form.scoringCriteriaList.length + 1 });
      },
      removeClick(index) {
        this.form.scoringCriteriaList.splice(index);
      },
      async getList() {
        this.tableLoading = true;
        const {
          status,
          message,
          data,
        } = await indicatorSettingsGrading(this.form.id);
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        if (data.length === 0) {
          this.form.scoringCriteriaList = [{
            startPrice: 0,
            sort: 1,
          }];
        } else {
          this.form.scoringCriteriaList = data;
        }
      },
      dialogOpen(title, basicId, row) {
        this.dialogTitle = title;
        this.form = JSON.parse(JSON.stringify(this.defaultForm));
        this.basicId = basicId;
        if (row) {
          this.form = JSON.parse(JSON.stringify(row));
          this.getList();
        }
        this.dialogVisible = true;
      },
      dialogClose() {
        this.dialogVisible = false;
      },
      submit() {
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            let data;
            this.submitLoading = true;
            if (this.form.id) {
              data = await indicatorSettingsInfoUpdate({
                ...this.form,
                basicId: this.basicId,
              });
            } else {
              data = await indicatorSettingsInfoAdd({
                ...this.form,
                basicId: this.basicId,
              });
            }
            this.submitLoading = false;
            if (data.status !== 0) return this.$message.warning(data.message);
            this.$message.success(data.message);
            this.dialogClose();
            this.$emit('searchBtn');
          }
        });
      },
      clearTable() {
        if (this.form.examineTarget === '1') return this.form.scoringCriteriaList = [];
        return this.form.scoringCriteriaList = [{
          startPrice: 0,
          sort: 1,
        }];
      },
    },
  };
</script>

<style lang='scss' scoped>
  .dialogForm {
    width: 90%;
    margin: 0 auto;
  }

  ::v-deep {
    .el-form-item__content .el-input-group {
      vertical-align: revert;
    }
  }
</style>
